import { type FieldValues } from 'react-hook-form'

import { type IUploadTransferResponse } from '@/models'
import { submitRequest } from '@/util'

export class SignUpService {
  async uploadTransfer (userId: string, payload: FieldValues): Promise<string> {
    const response = await submitRequest<IUploadTransferResponse>(
      'post',
      'v1/media/sign-up/transfer-upload',
      { ...payload, userId },
      undefined,
      { 'Content-Type': 'multipart/form-data' }
    )

    if (response.success) {
      return response.id
    } else {
      throw new Error(response.message)
    }
  }
}
